import { createGetFullKeyEndpointFromExisting } from './createGetFullKeyEndpointFromExisting';
import { ApiEndpointHandler, createGetEndpoint, EndpointOptions, UriSource } from '@sonar-software/sonar-http';
import { KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export function createGetFullKeyEndpoint<
	TResult,
	TRequest extends KeyPaginationQueryParams,
	TResponse extends PaginatedResource<TResult>
>(
	uri: UriSource<TRequest>,
	options?: EndpointOptions<TRequest> & { count: number }
): ApiEndpointHandler<TRequest, TResponse> {
	const base = createGetEndpoint<TRequest, TResponse>(uri, options);

	return createGetFullKeyEndpointFromExisting(base, options?.count);
}
